import './GalleriesPage.css';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, Link as RouterLink } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import { loadCategories } from '../actions/categoryActions';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import FbImage from '../common/components/fb_image/FbImage';
import { trackGalleryClick, trackNavigation } from '../common/utils/analytics';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import MuiLink from '@mui/material/Link';
import HomeIcon from '@mui/icons-material/Home';
import SEO from '../common/components/seo/SEO';
import { getBreadcrumbStructuredData } from '../common/utils/structuredData';

function GalleriesPage() {

    const dispatch = useDispatch();
    const categories = useSelector(state => state.category.categories);

    useEffect(() => {
        dispatch(loadCategories());
    }, [dispatch]);


    const breadcrumbData = getBreadcrumbStructuredData([
        { name: 'Home', url: '/' },
        { name: 'Galleries', url: '/galleries' },
    ]);

    return (
        <>
            <SEO
                title="Photo Galleries - Landscape Photography Categories"
                description="Browse landscape photography galleries organized by category. Explore mountains, waterfalls, deserts, lakes, coast, glaciers, and more stunning natural scenes captured by ValeTer."
                keywords="landscape photography galleries, nature photography categories, photo galleries, landscape photo collections"
                structuredData={breadcrumbData}
            />
            <Paper className='galleries-page'>
                <Breadcrumbs separator="›" aria-label="breadcrumb" className='enhanced-breadcrumbs'>
                <MuiLink 
                    component={RouterLink}
                    underline="hover" 
                    color="inherit" 
                    to="/"
                    onClick={() => trackNavigation('Breadcrumb: Home')}
                    sx={{ display: 'flex', alignItems: 'center' }}
                >
                    <HomeIcon sx={{ mr: 0.5 }} fontSize="small" />
                    Home
                </MuiLink>
                <Typography color="text.primary">Galleries</Typography>
            </Breadcrumbs>
            <ImageList
                sx={{
                    width: '100%',
                    overflow: 'hidden',
                    gridTemplateColumns:
                        'repeat(auto-fill, minmax(400px, 12fr))!important',
                    justifyContent: 'center',
                    margin: '8px',
                }}
                cols={3}
                gap={8}
            >
                {(categories ?? []).map((g) => (
                    <ImageListItem key={g.id} className='gallery-card'>
                        <div className='gallery-card-cell'>
                            <Link 
                                className='cell-content' 
                                to={`/galleries/${g.id}`}
                                onClick={() => trackGalleryClick(g.categoryName)}
                            >
                                <FbImage
                                    path={g.coverMediumPath || g.coverPath}
                                    thumbnailPath={g.coverThumbnailPath}
                                    alt={g.categoryName}
                                />
                            </Link>
                            <ImageListItemBar
                                sx={{
                                    '.MuiImageListItemBar-title': {
                                        fontSize: '24px',
                                    },
                                }}
                                title={g.categoryName}
                            />
                        </div>
                    </ImageListItem>
                ))}
            </ImageList>
        </Paper>
        </>
    );
}

export default GalleriesPage;
